import React from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import styled from 'styled-components';

const ContactForm = styled.div`
  height: auto;

  & p {
    margin: 0;
    padding: 18px;
    width: 100%;

    border: 2px solid #d27dff;
    background-color: #fff;

    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-start;
  }
  & p:nth-child(2) {
    border-bottom: 0;
  }
  & label {
    color: #d27dff;
  }
  & input,
  textarea {
    margin-left: 18px;
    width: calc(100% - 65px - 18px);
    border: 0;
    -webkit-appearance: none;
    padding: 0;
    &:focus {
      outline: none;
    }
  }

  & input {
    height: 22px;
    position: relative;
    line-height: 1;
  }
  & button {
    display: flex;
    justify-content: space-between;

    padding: 17px;
    margin: 0;

    width: 100%;

    border: 0;
    -webkit-appearance: none;

    background-color: #000;
    color: #fff;

    cursor: pointer;
  }
`;

const ContactHeader = styled.div`
  background-color: #d27dff;

  color: #fff;
  text-align: center;
  font-size: 20px;

  padding: 17px;
`;

const MailchimpTitle = styled.p`
  color: #d27dff;
  text-align: center;
  font-size: 17px;

  padding: 38px 0 18px 0;
`;

const MailchimpFormContainer = styled(ContactForm)`
  & p:nth-child(1) {
    border-bottom: 0;
  }

  & p:nth-child(2) {
    padding: 0;
    margin-top: 17px;

    border: 0;
    background-color: #dcbeff;
  }

  & p.mailchimp-feedback {
    padding: 12px 18px 0;
    margin-top: 0;

    border: 0;
    background-color: transparent;

    display: block;
    color: #000;
    font-size: 14px;
    line-height: 1.4;
  }

  & p {
    & input,
    textarea {
      width: calc(100% - 120px - 18px);
    }
  }
`;

const Arrow = styled.span`
  line-height: 14px;
`;

const MailchimpText = styled.div``;

/** Mailchimp returns HTML in msg; strip for plain-text UI. */
function mailchimpMsgToPlainText(msg) {
  if (msg == null) return '';
  return String(msg)
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

class MailchimpForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      EMAIL: null,
      message: '',
    };
  }

  handleChangeMailchimp = e => {
    this.setState({
      [`${e.target.name}`]: e.target.value,
    });
  };

  submitMailchimp = e => {
    e.preventDefault();

    addToMailchimp(this.state.EMAIL)
      .then(({ msg, result }) => {
        if (result === 'success') {
          this.setState({
            message: mailchimpMsgToPlainText(msg) || 'Thank you for subscribing!',
          });
        } else {
          this.setState({
            message: mailchimpMsgToPlainText(msg) || 'Something went wrong. Please try again.',
          });
        }
      })
      .catch(err => {
        let text =
          err && typeof err.message === 'string'
            ? err.message
            : 'Unable to reach the signup service. Check your connection or try again.';
        if (text === 'Timeout') {
          text =
            'Signup timed out. Try again, or allow list-manage.com if you use an ad or privacy blocker.';
        }
        this.setState({ message: text });
        console.error('Mailchimp signup failed', err);
      });
  };

  render(props) {
    const email = this.state.EMAIL;
    const canSubmit =
      typeof email === 'string' && email.trim().length > 0;

    return (
      <React.Fragment>
        <MailchimpTitle>{this.props.signupText}</MailchimpTitle>
        <MailchimpFormContainer>
          <ContactHeader>NEWSLETTER SIGN-UP</ContactHeader>

          <form onSubmit={this.submitMailchimp}>
            <p>
              <label htmlFor="mailchimp-contact-email">Email address</label>
              <input
                id="mailchimp-contact-email"
                type="email"
                name="EMAIL"
                autoComplete="email"
                required
                onChange={this.handleChangeMailchimp}
                placeholder="Email address"
              />
            </p>

            <p>
              <button type="submit" disabled={!canSubmit}>
                SIGN UP <Arrow>→</Arrow>
              </button>
            </p>
            {this.state.message ? (
              <p className="mailchimp-feedback">{this.state.message}</p>
            ) : null}
          </form>
        </MailchimpFormContainer>

        <MailchimpText>
          <p>
            We use Mailchimp as our marketing platform. By clicking above to
            subscribe, you acknowledge that your information will be transferred
            to Mailchimp for processing.{' '}
            <a
              href="https://mailchimp.com/legal/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more about Mailchimp's privacy practices here.
            </a>
          </p>
        </MailchimpText>
      </React.Fragment>
    );
  }
}

export default MailchimpForm;
